<template lang="pug">
  b-container
    b-row(class="justify-content-md-center")
      b-col.text-center.top-message(col md="12" lg="7")
        Message(
          :fontSizes="[40, 24]"
          title="A data-driven approach to strategic decision-making"
          subtitle="Business and investment rationales are only as sound as the fact bases supporting them. By extracting key insights from the white noise of online information, we consistently provide our users with the most relevant information basis."
        )
      b-col(cols="12" v-for="(section, i) of sections" :key="section.key")
        ComboImageTile(
          :title="section.title"
          :subtitle="section.text"
          :icon="section.image"
          :direction="section.direction"
        )
</template>
<script type="text/javascript">

import ComboImageTile from '@/components/Home/ComboImageTile.vue'
import Message from '@/components/Shared/Message.vue'

export default {
  name: 'Approach',
  data () {
    return {
      sections: [
        {
          key: 'data',
          title: 'Focus on leveraging data available online',
          text: 'Online-available information is plentiful and growing exponentially. Yet in most sectors, executives have long lacked the tools to make the most of it. We deliver software solutions continuously gathering, analyzing and rendering such data to support private market investors and business executives in their decision-making.',
          image: 'online-data.jpg',
          direction: 1
        },
        {
          key: 'extraction',
          title: 'Best-in-class information extraction techniques',
          text: 'We use algorithmic information retrieval, natural language processing and machine learning to extract targeted data from online sources. Many of our algorithms run continuously to keep facts up-to-date. Our proprietary tools help cut through the noise of vast, fragmented, unstructured and constantly-changing datasets.',
          image: 'mktBI-code-2-min.png',
          direction: 0
        },
        {
          key: 'dashboards',
          title: 'Insightful digital dashboards',
          text: 'We seek to go beyond providing yet another dataset. We analyze the raw data gathered and present key insights in structured, visual and interactive online dashboards. For maximum relevance, our multidisciplinary team with significant business due diligence experience incorporates substantial sector-specific knowledge.',
          image: 'mktBI-Web-App-4-min.png',
          direction: 1
        }
      ]
    }
  },
  components: {
    ComboImageTile,
    Message
  }
}  
</script>


<style scoped lang="scss">
  $color-title: #364149;
  $color-subtitle: #767F86;
  .top-message {
    padding-bottom: 1em;
  }
  .body{
    display: flex;
    flex-direction: column;
    justify-content: center;
    .header {
      display: flex;
      flex-direction: column;
      width: 760px;
      .title {
        color: $color-title;
        font-weight: bold;
        font-size: 50px;
        line-height: 60px;
        margin: 50px 0 30px 0;
        padding-top: 30px;
      }
      .subtitle {
        color: $color-subtitle;
        font-weight: normal;
        font-size: 24px;
        line-height: 32px;
        
      }
    }
    .section{
      display: flex;
      flex-direction: row;
      margin: 0px 0px 0px 100px;
      .textpart {
        display: flex;
        flex-direction: column;
        width: 40%;
        .title {
          color: $color-title;
          font-weight: bold;
          font-size: 1.875em;
        }
        .subtitle {
          color: $color-subtitle;
          font-weight: normal;
          font-size: 1em;
        }
      }
    }
  }
</style>